var notificationsManager = require('notificationsManager');

var _lastInput = null;
var _lastResult = null;

function getMappedNotifications(notificationsData) {
  if (notificationsData === _lastInput && _lastResult !== null) {
    return _lastResult;
  }
  var result = notificationsManager.notificationsDataMap(notificationsData) || {
    allNotifications: [],
    currentFieldNotifications: [],
  };
  _lastInput = notificationsData;
  _lastResult = result;
  return result;
}

function getLatestNotificationDate(items) {
  if (!items || items.length === 0) return 0;
  return Math.max.apply(
    null,
    items.map(function (item) {
      return item.date || 0;
    }),
  );
}

module.exports = { getMappedNotifications, getLatestNotificationDate };
